
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Mumbaitopunedailycabs() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Daily Cab',
        heading: 'Mauli Cabs: Mumbai to Pune Daily Cab',
        headingDescription: 'Mauli Cabs offers dependable and punctual Mumbai to Pune daily cab services, ideal for regular commuters, business travelers, and frequent visitors. With a fleet of well-maintained sedans, SUVs, and premium cabs, we ensure a comfortable and hassle-free ride every day. Our professional drivers, transparent pricing, zero hidden charges, and strong commitment to timeliness and customer satisfaction make Mauli Cabs the perfect choice for your daily travel needs between Mumbai and Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "Mumbai to Bhosari Cab Service",
      "description": "Book a comfortable and timely cab service from Mumbai to Bhosari, Pune. Whether you're traveling for work, leisure, or any personal reason, our drivers ensure a smooth ride. We offer a range of vehicles including economy cabs, SUVs, and luxury options, all equipped with the latest amenities for your convenience."
    },
    {
      "name": "Mumbai to Camp Pune Cab",
      "description": "Travel from Mumbai to Camp, Pune, with our reliable taxi service. Our experienced drivers take the most efficient routes to ensure you reach your destination on time. Choose from a variety of cars based on your comfort and budget, from economy sedans to premium vehicles."
    },
    {
      "name": "Mumbai to Sinhagad Road Cab",
      "description": "Book a safe and comfortable cab ride from Mumbai to Sinhagad Road, Pune. Our fleet includes vehicles for solo travelers, families, and large groups. Whether you're heading for a historical trip or visiting family, we provide convenient pick-ups and drop-offs at your specified location."
    },
    {
      "name": "Mumbai to Hinjewadi Taxi Fare",
      "description": "Check out affordable and transparent taxi fares for your ride from Mumbai to Hinjewadi. Whether it's a business meeting or a weekend getaway, our service offers well-maintained vehicles and professional drivers. We ensure no hidden charges and offer multiple payment options for your convenience."
    },
    {
      "name": "Mumbai to Wakad Cab",
      "description": "Book a dependable cab from Mumbai to Wakad, Pune. Enjoy a smooth, hassle-free ride with well-maintained vehicles, courteous drivers, and door-to-door service. Ideal for business professionals and tourists, our cab service ensures on-time arrival at affordable prices."
    },
    {
      "name": "Mumbai to Aundh Daily Cab Fare",
      "description": "Explore affordable daily cab fares for regular rides between Mumbai and Aundh, Pune. With flexible booking options, we ensure timely and convenient travel. Whether it's a one-way or round-trip journey, our vehicles cater to daily commuters, offering both comfort and affordability."
    },
    {
      "name": "Mumbai to Koregaon Park Daily Cab Fare",
      "description": "Book your daily cab rides between Mumbai and Koregaon Park at competitive fares. Our services are designed for regular commuters, providing comfort, flexibility, and punctuality. Choose from a variety of vehicles suited for your daily travel needs."
    },
    {
      "name": "Mumbai to Pune Daily Innova Fare",
      "description": "Looking for a daily ride between Mumbai and Pune? Book our Innova cabs for your regular commute at an affordable fare. The Toyota Innova offers ample space, superior comfort, and reliability for business and personal travelers alike."
    },
    {
      "name": "Mumbai to Pune Daily Ertiga Fare",
      "description": "For daily commutes between Mumbai and Pune, the Maruti Ertiga is a perfect choice. Offering great fuel efficiency, ample space, and comfortable seating, this vehicle is perfect for family or group travel. Get transparent pricing and enjoy a smooth journey every day."
    },
    {
      "name": "Mumbai to Pune Daily Sedan Cab Fare",
      "description": "Choose our sedan cabs for your daily ride between Mumbai and Pune. Comfortable and fuel-efficient, these vehicles are ideal for solo travelers or small groups. Our daily fares are designed to provide you with affordable, reliable, and consistent transportation."
    },
    {
      "name": "Mumbai Pune Daily Cab Service",
      "description": "Get a dedicated daily cab service between Mumbai and Pune. Whether you need a one-way ride or round-trip service, our fleet offers a variety of vehicle options including sedans, SUVs, and MPVs. We ensure punctual pickups and comfortable travel every day."
    },
    {
      "name": "Mumbai to Pimpri Daily Cab",
      "description": "Our daily cab service from Mumbai to Pimpri ensures comfort and convenience for commuters. With options ranging from sedans to MPVs, our cabs are ideal for individuals and small groups traveling daily between the two cities. Choose the best vehicle for your needs at an affordable price."
    },
    {
      "name": "Cheapest Cab Mumbai to Pune",
      "description": "Looking for the most affordable ride from Mumbai to Pune? Our cheapest cab options provide you with budget-friendly fares without compromising on comfort or safety. Get the best value for your money with no hidden charges and transparent pricing."
    },
    {
      "name": "Mumbai Airport to Pune Daily Cab Service",
      "description": "Enjoy daily cab services from Mumbai Airport to Pune with the convenience of door-to-door service. Our vehicles are equipped with GPS, air conditioning, and comfortable seating, ensuring a smooth transfer from the airport to any part of Pune."
    },
    {
      "name": "Mumbai Airport to Viman Nagar Cab Service",
      "description": "Travel from Mumbai Airport to Viman Nagar with our reliable taxi service. Ideal for business travelers and tourists, our cab service offers comfortable vehicles, professional drivers, and timely service to ensure you reach your destination in a hassle-free manner."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Fare",
      "description": "Get clear and competitive pricing for a taxi ride from Mumbai Airport to Pune. Our service ensures transparency with no hidden charges. Choose from various vehicle categories like sedans, SUVs, or premium cars based on your preferences and budget."
    }
  ],
  "tableData": [
    ["Mumbai to Bhosari Cab Service", "Mumbai to Camp Pune Cab"],
    ["Mumbai to Sinhagad Road Cab", "Mumbai to Hinjewadi Taxi Fare"],
    ["Mumbai to Wakad Cab", "Mumbai to Aundh Daily Cab Fare"],
    ["Mumbai to Koregaon Park Daily Cab Fare", "Mumbai to Pune Daily Innova Fare"],
    ["Mumbai to Pune Daily Ertiga Fare", "Mumbai to Pune Daily Sedan Cab Fare"],
    ["Mumbai Pune Daily Cab Service", "Mumbai to Pimpri Daily Cab"],
    ["Cheapest Cab Mumbai to Pune", "Mumbai Airport to Pune Daily Cab Service"],
    ["Mumbai Airport to Viman Nagar Cab Service", "Mumbai Airport to Pune Taxi Fare"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Daily Cab Service from Mumbai to Pune",
        "WhyChoosedescription": "Mauli Cabs provides reliable daily cab services from Mumbai to Pune, ideal for office commuters, business travelers, and frequent flyers who need consistent and timely transport."
    },
    {
        "WhyChooseheading": "Comfortable and Sanitized Vehicles",
        "WhyChoosedescription": "Enjoy clean, air-conditioned vehicles that are regularly sanitized. Choose from sedans, SUVs, or premium cars for a smooth and comfortable daily travel experience."
    },
    {
        "WhyChooseheading": "Professional Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are trained and experienced in the Mumbai to Pune route. They ensure safe and timely travel every day, avoiding peak-hour congestion wherever possible."
    },
    {
        "WhyChooseheading": "Fixed and Transparent Daily Rates",
        "WhyChoosedescription": "Get fixed, affordable pricing with no hidden costs. Our daily cab packages are designed to offer the best value for your regular travel between Mumbai and Pune."
    },
    {
        "WhyChooseheading": "Available 24/7 for Daily Commutes",
        "WhyChoosedescription": "Whether it’s an early start or a late return, Mauli Cabs is available 24/7 to suit your daily commuting schedule from Mumbai to Pune."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Tracking",
        "WhyChoosedescription": "Book in seconds using our website or mobile app. Get real-time updates, driver information, and ETA alerts for a smooth and predictable daily ride."
    },
    {
        "WhyChooseheading": "Safe, Verified, and Hygienic Travel",
        "WhyChoosedescription": "Our cabs are thoroughly sanitized, and all drivers are background-verified to ensure a secure and worry-free daily travel experience."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Pay easily with UPI, cards, wallets, or cash. We offer convenient and secure payment methods to match your daily travel needs."
    }
]



























    }

    const faqData = [
        {
            question: 'Can I book a daily cab from Mumbai to Pune with Mauli Cabs?',
            answer: 'Yes, Mauli Cabs offers daily cab services from Mumbai to Pune. Whether it’s for work, business, or personal travel, you can conveniently book your daily ride through our website or mobile app. We also offer recurring booking options for regular travelers.',
        },
        {
            question: 'What types of cabs are available for the daily Mumbai to Pune commute?',
            answer: 'For daily travel between Mumbai and Pune, Mauli Cabs offers a wide range of vehicles including Hatchbacks, Sedans, SUVs, Ertiga, and Innova Crysta. Choose based on your comfort, budget, and luggage needs.',
        },
        {
            question: 'Is the fare for daily Mumbai to Pune cabs fixed?',
            answer: 'Yes, the fare is fixed and all-inclusive, covering tolls, fuel, taxes, and driver charges. We provide upfront pricing with no hidden fees, so you can plan your daily travel expenses without surprises.',
        },
        {
            question: 'How long does the Mumbai to Pune daily cab journey take?',
            answer: 'The journey typically takes 3.5 to 5 hours depending on traffic and weather conditions. For daily travel, we recommend booking during non-peak hours to reduce commute time.',
        },
        {
            question: 'Can I get a cab at a fixed time daily from Mumbai to Pune?',
            answer: 'Yes, we offer scheduled pickups for daily travelers. You can set a regular pickup time, and we’ll ensure a cab is available for you each day at your chosen hour.',
        },
        {
            question: 'Are early morning and late-night daily cabs available from Mumbai to Pune?',
            answer: 'Yes, Mauli Cabs operates 24/7, making it easy for you to book a cab at any time of day or night, even for daily travel. Early morning and late-night rides are also available on request.',
        },
        {
            question: 'Can I carry extra luggage in my daily cab from Mumbai to Pune?',
            answer: 'Yes, you can carry luggage with you during your daily commute. If you have larger or additional bags, we recommend booking an SUV or Innova Crysta for extra space and comfort.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Akash Jadhav",
            position: "Software Engineer",
            text: "I use Mauli Cabs daily for my commute from Mumbai to Pune. The service is consistent, the cars are always clean, and the drivers are reliable. It’s made my work travel so much easier.",
            image: "/img/testimonial/testimonial-thumb-1-39.png",
        },
        {
            name: "Miss. Neha Pandit",
            position: "Travel Blogger",
            text: "Mauli Cabs is my go-to for daily trips between Mumbai and Pune. The rides are punctual and comfortable every single time. Highly recommended for professionals and regular commuters.",
            image: "/img/testimonial/testimonial-thumb-1-40.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Pune Daily Cab",
        "description": "Mauli Cabs offers daily taxi service from Mumbai to Pune with affordable rates for frequent commuters. Choose from Innova Crysta, Ertiga, or sedan cabs for a reliable, daily commute.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "5465"
        }
      };
      
     
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Mumbai to Pune Daily Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a daily cab from Mumbai to Pune with Mauli Cabs. Affordable taxi service for daily commuting to locations like Bhosari, Camp Pune, Sinhagad Road, Hinjewadi, Wakad, and more. Choose from Innova Crysta, Ertiga, or sedan cabs."
        />
        <meta
          name="keywords"
          content="mumbai to bhosari cab service, mumbai to camp pune cab, mumbai to sinhagad road cab, mumbai to hinjewadi taxi fare, mumbai to wakad cab, mumbai to aundh daily cab fare, mumbai to koregaon park daily cab fare, mumbai to pune daily innova fare, mumbai to pune daily ertiga fare, mumbai to pune daily sedan cab fare, mumbai pune daily cab service, mumbai to pimpri daily cab, cheapest cab mumbai to pune, mumbai airport to pune daily cab service, mumbai airport to viman nagar cab service, mumbai airport to pune taxi fare"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/103.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitopunedailycabs;